var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-index"},[_c('Header',{attrs:{"typeFu":1}}),_c('div',{staticClass:"big-right"},[_c('div',{staticClass:"info-box"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }